
export const nuevosCapitulos = [
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 5
    },
    {
        img: "https://e7.pngegg.com/pngimages/599/744/png-clipart-bts-eye-manga-anime-hair-kuroko-bts-eye.png",
        title: "mujer azul eeeee eeeeeeeeeee eeeeee",
        capitulo: 5
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/236x/af/1c/30/af1c30d6d881d9447dec06149f61d2f9--drawings-of-girls-anime-drawings-girl.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
    {
        img: "https://i.pinimg.com/474x/0e/3e/d0/0e3ed05ff407671bdebf77b53ce0e0b9.jpg",
        title: "mujer azul",
        capitulo: 2
    },
]


export const abc = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "0-9",
];


export const date = [
    "2022",
    "2021",
    "2020",
    "2019",
    "2018",
    "2017",
    "2016",
    "2015",
    "2014",
    "2013",
    "2012",
    "2011",
    "2010",
    "2009",
    "2008",
    "2007",
    "2006",
    "2005",
    "2004",
    "2003",
    "2002",
    "2001",
    "2000",
    "1999",
    "1998",
    "1997",
    "1996",
    
];


export const dataGenre = [
    "Acción",
    "Autos","Aventura","Colegio", 
    "Comedia","Demonios","Deportes","Drama",
    "Fantasia","Hatem","Hentai","Historia",
    "Juegos","Magia","Militar","Misterio","Música",
    "Psicología",
    "Romance","Samurai","Terror"
]

export const dataCategory = [
    "Anime",
    "Pelicula",
    "Ova"
] 

